import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
} from "@mui/material";
import { JumboCard } from "themes/jumbo/@jumbo/components";
import { ReportItem, EmptyReportItem } from "./ReportItem";
import { useSelector } from 'react-redux';
import { tss } from "tss-react";
import { FoldersActions } from "actions";
import { useHistory } from 'react-router-dom';
import { getFileIcon } from "actions/GlobalActions";
import * as Utils from "services/UtilsService";
import { Div } from "themes/jumbo/@jumbo/shared";

const useStyles = tss.create(() => ({
  tableTr: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    textAlign: 'left',
    padding: '16px',
    color: 'rgb(71, 82, 89)',
    borderTopColor: 'rgba(0, 0, 0, 0.1)',
    borderRightColor: 'rgba(0, 0, 0, 0.1)',
    bordTransform: 'uppercase',
    letterSpacing: '1.5px',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: 1.25,
    background: 'rgba(0, 0, 0, .08)'
  }
}));

const define_status = (str: string) => {
  return typeof str === "string" && str.length > 0 ? str : "Report processing...";
};

const ReportList = () => {
	const data = useSelector((state: any) => state.cache.data);
  const projects = data.projects;
  const { classes } = useStyles();
  const reportsData: any[] = [];
  const history = useHistory();
  const catalog = FoldersActions.getCatalog("0");
  const entities = FoldersActions.getReportHierarchy(catalog);
  const _list = Object.values([...entities]);

  
  const storeAuthData = useSelector((state: any) => state.auth);
  const { defaultProjects } = storeAuthData;
  const demoProjectsHidden = Number(localStorage.getItem('hideDemoProjects') || 0) > 0;
  let list = _list.filter((item: any) => !demoProjectsHidden || !defaultProjects.includes(item.ID)) 

  if (list.length > 0) {
    if (list[0].type === "PROJECT") {
        list = Utils.sortArrayByProp(list, "name");
    } else {
        //Folders and files inside a project must be rendered by folder first, then files. Those must then be ordered by date DESC (newest first).
        const folderList = list.filter((entity: any) => entity.type === "FOLDER");
        const fileList = list.filter((entity: any) => entity.type !== "FOLDER");
        list = Utils.sortArrayByProp(folderList, "date", true, true).concat(
            Utils.sortArrayByProp(fileList, "date", true, true)
        );
    }
  }
  list.map((entity: any, index: number) => {
    if(!entity) return;
    const { name, type, project:projectID } = entity;
    reportsData.push({
      projectID,
      projectName: projects[projectID]?.name,
      name,
      type,
      hasSubFolders: entity.subFolders ? entity.subFolders.length > 0 : false
    })
  })

  const handleClick = (e: any) => {
      history.push(`/reports`);
  };

  return (
    <JumboCard>
      <TableContainer sx={{height: '450px'}}>
        <Table /*sx={{ minWidth: 400 }}*/>
          <TableHead>
            <TableRow
              sx={{
                "th:first-of-type": {
                  pl: 3,
                },
                "th:last-child": {
                  pr: 3,
                },
              }}
            >
              <TableCell className={classes.tableTr}>REPORT</TableCell>
              <TableCell className={classes.tableTr} style={{textAlign: 'right'}}>
              <Button
                size={'small'}
                variant='outlined'
                onClick={handleClick}
              >
                See All
              </Button>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reportsData.length > 0 ?  (
              reportsData.sort((a:any, b:any) => b.date - a.date).slice(0, 7).map((item: any, index: Number) => (
                <ReportItem item={item} key={`${item.ID}-${index}`} index={index} />
              ))
            ) : (
              <EmptyReportItem />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </JumboCard>
  );
};
export { ReportList };
